<template>
  <v-card class="pa-4">
    <v-card-title>{{ $t('title') }}</v-card-title>
    <v-card-text>
      <v-text-field
          :label="$t('label-app')"
          :value="version"
          prepend-icon="mdi-cog"
          readonly
          :hint="$t('hint-app')"
          persistent-hint>
        <v-btn
            slot="append-outer"
            @click="checkForUpdate"
            :loading="loading.checkForUpdate">
          {{ $t('check-update') }}
        </v-btn>
      </v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Application',
  data () {
    return {
      loading: {
        checkForUpdate: false
      },
    }
  },
  computed: {
    version () {
      return this.$ui.app.version
    }
  },
  methods: {
    async checkForUpdate () {
      this.loading.checkForUpdate = true
      await this.$ui.checkForUpdate({ reloadIfNoWOrker: true })
      this.loading.checkForUpdate = false
    }
  }
}

</script>

<i18n>
{
	"en": {
		"check-update": "Check update",
		"hint-app": "The version of the app you are currently using.",
		"label-app": "Application version",
		"title": "Application and update"
	},
	"es": {
		"check-update": "Comprueba la actualización",
		"hint-app": "La versión de la aplicación que está usando actualmente.",
		"label-app": "Versión de la aplicación",
		"title": "Aplicación y actualización"
	},
	"fr": {
		"check-update": "Vérifier mise à jour",
		"hint-app": "La version de l'application que vous utilisez actuellement.",
		"label-app": "Version de l'application",
		"title": "Application et mise à jour"
	},
	"it": {
		"check-update": "Controlla aggiornamenti",
		"hint-app": "La versione dell'applicazione che stai usando.",
		"label-app": "Versione dell'applicazione",
		"title": "Applicazione e aggiornamento"
	},
	"pt": {
		"check-update": "Verificar atualização",
		"hint-app": "A versão da aplicação que está a utilizar atualmente.",
		"label-app": "Versão da aplicação",
		"title": "Aplicação e atualização"
	},
	"pl": {
		"check-update": "Sprawdź aktualizację",
		"hint-app": "Wersja aplikacji, której aktualnie używasz.",
		"label-app": "Wersja aplikacji",
		"title": "Aplikacja i aktualizacja"
	}
}
</i18n>
